import { AeoPromptTagSchema } from "@redotech/redo-model/aeo/prompt";
import * as z from "zod/v4";

export const setAeoPromptTags = {
  name: "setAeoPromptTags" as const,
  input: z.object({ promptId: z.bigint(), tagIds: z.array(z.bigint()) }),
  output: z.object({ tags: z.array(AeoPromptTagSchema) }),
};
